// extracted by mini-css-extract-plugin
module.exports = {"footer":"_ReactionFooter_footer_31G1_","bar":"_ReactionFooter_bar_14nlv"};